/* eslint-disable react-hooks/exhaustive-deps */
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { useSendOtpCodeMutation, useVerifyOtpCodeMutation } from "../redux/api/phoneVerificationApiSlice";
import { setOtpCode, setPhoneNo } from '../redux/userSlice';
import setPageAndDeferNavigate from "../lib/setPageAndDeferNavigate";

export const useAuth = ({ onSuccess } = {}) => {
  const [phoneNoValid, setPhoneNoValid] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sendOtpCode, { isLoading: isSendingOtp, data, isSuccess: isOTpSentSuccess, isError: isSendError, error: sendOtpErr }] = useSendOtpCodeMutation();
  const [verifyOtpCode, { isSuccess: isVerifiedSuccessful, isError: isVerifyOtpErr, error: verifyOtpError }] = useVerifyOtpCodeMutation();
  const user = useSelector((store) => store.user);

  useEffect(() => {
    if (user?.phoneNo !== null) {
      const phoneNoValid = isValidPhoneNumber(user?.phoneNo ?? "");
      setPhoneNoValid(phoneNoValid);
    }
  }, [user?.phoneNo]);

  useEffect(() => {
    if (isOTpSentSuccess) {
      setShowOtpInput(true);
      toast.success(data.msg);
    }
    if (isSendError) {
      toast.error(sendOtpErr?.message ?? "Failed to send OTP code");
    }
  }, [isSendError, isOTpSentSuccess, data, sendOtpErr]);

  useEffect(() => {
    if (user?.otpCode?.length >= 6 && showOtpInput && user.phoneNo) {
      verifyOtpCode({
        phone_number: user?.phoneNo,
        code: user?.otpCode
      });
    }
  }, [user?.otpCode, user?.phoneNo, verifyOtpCode]);

  useEffect(() => {
    if (isVerifiedSuccessful) {
      toast.success("OTP code verified successfully");

      if (onSuccess) {
        onSuccess();
      } else if (user.returning) {
        setPageAndDeferNavigate(dispatch, '/returning-patient', navigate);
      } else {
        navigate("/error");
      }
    }

    if (isVerifyOtpErr) {
      handleChange("otpCode", null);
      toast.error(verifyOtpError?.data?.message ?? "Failed to verify OTP code");
    }
  }, [isVerifyOtpErr, isVerifiedSuccessful, navigate, verifyOtpError]);

  function handleChange(name, value) {
    if (name === "phoneNo") {
      dispatch(setPhoneNo(value));
    } else if (name === "otpCode") {
      dispatch(setOtpCode(value));
    }
  }

  function isValidPhoneNumber(phoneNumber) {
    const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber);
    return parsedPhoneNumber && parsedPhoneNumber.isValid();
  }

  function sendOtp() {
    sendOtpCode({
      phone_number: user.phoneNo
    });
  }

  return { handleChange, user, phoneNoValid, sendOtp, showOtpInput, isSendingOtp, isVerifyOtpErr, setShowOtpInput };
};